import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import './index.css';

import './lazyload';


// 设置宝盒分享的标题和描述
if (/ztobox|ztbox|baohe/.test(navigator.userAgent.toLowerCase())) {
    const location = global.location;
    const url = `${location.protocol}//${location.hostname}${location.port ? ":" + location.port : ""}${location.pathname}`;

    if (global.zt && global.zt.setTitle && global.PageTitle) {
        global.zt.setTitle({
            title: global.PageTitle,
            bgcolor: '#ffffff'
        });
    }

    if (global.zt && global.zt.updateShareContent) {
        const shareConfig = {
            title: global.PageTitle || '',
            desc: global.Title || '',
            thumbImageUrl: global.AppIcon || '',
            webpageUrl: url,
            timeline: global.Title || '',
        };
        global.zt.updateShareContent(shareConfig);
    }
}


ReactDOM.render(
  <App />,
  document.getElementById('root') as HTMLElement
);



// WEBPACK FOOTER //
// ./src/index.tsx